//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import { GetTokenInfo } from "@/services/auth.js";
export default {
  data() {
    return {
      accessToken: null,
      initialPagination: {
        rowsPerPage: 20
      },
      columns: [
        {
          name: "id",
          required: true,
          align: "right",
          field: row => row.id,
          format: val => `${val}`
        },
        {
          name: "name",
          required: true,
          label: "Track Name",
          align: "left",
          field: row => row.name,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: "popularity",
          required: false,
          label: "Popularity",
          align: "left",
          field: row => row.popularity,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: "uri",
          required: true,
          label: "",
          align: "right",
          field: row => row.uri,
          format: val => `${val}`
        }
      ]
    };
  },
  computed: {
    visibleColumns() {
      return [
        "id",
        "name",
        this.tracks.find(x => x.popularity) ? "popularity" : "",
        "uri"
      ];
    }
  },
  methods: {
    enqueue(trackId) {
      GetTokenInfo().then(token => {
        this.accessToken = token.accessToken;
        axios
          .post(
            `https://api.spotify.com/v1/me/player/queue?uri=${trackId}`,
            null,
            {
              headers: {
                authorization: `Bearer ${this.accessToken}`
              }
            }
          )
          .then(() => {
            var track = this.tracks.find(x => x.uri == trackId);
            this.$q.notify({
              progress: true,
              color: "accent",
              message: `Added "${track.name}" to your play queue`,
              position: "top",
              timeout: 2500
            });
          })
          .catch(() => {});
      });
    }
  },
  props: {
    title: {
      type: String
    },
    tracks: {
      type: Array,
      required: true
    },
    nowPlayingId: {
      type: String
    }
  }
};
